import * as React from "react";
export class SecondaryHeading extends React.PureComponent {
    render() {
        return (React.createElement("h4", { className: `rj-ev-list__sub-heading ${`rj-ev-list__sub-heading--${this.props.componentPrefix.toLowerCase()}`}`, "data-uat": "div-ev-list-sub-heading" }, this.props.children));
    }
}
//# sourceMappingURL=SecondaryHeading.js.map